import { render } from "./SMS_Templates.vue?vue&type=template&id=26b18486"
import script from "./SMS_Templates.vue?vue&type=script&lang=js"
export * from "./SMS_Templates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__